<template>
<BootstrapDialog title="修改密码" ref="dialog" size="lg" @afterClose="afterClose()">
	<template v-slot:body>
		<div class="modal-body wrapper-lg" style="width:100%">
		        <div class="row">
					<div class="col-sm-8 col-sm-offset-2">
						
		            <form class="form-horizontal">
		                <div class="form-group">
		                    <label class="control-label col-sm-3">新密码</label>
		                    <div class="col-xs-8">
		                        <input class="form-control" ref="xmm" type="password" placeholder="请输入新密码" v-validate="{required:true,max:50}"
		                               name="xmm" data-vv-as="密码" v-model="model.xmm"/>
		                       <span class="error_validate_msg"><em>{{ errors.first('xmm') }}</em></span>
		                    </div>
		                </div>
		                <div class="form-group">
		                    <label class="control-label col-sm-3">确认密码</label>
		                    <div class="col-xs-8">
		                        <input class="form-control" type="password" autocomplete="off" data-vv-as="确认密码" placeholder="请再次输入新密码"
		                               v-validate="{required:true,max:50,confirmed:'xmm'}" name="confirmPassword"
		                               v-model="model.confirmPassword"/>
		                        <span class="error_validate_msg"><em>{{ errors.first('confirmPassword')}}</em></span>
		                    </div>
		                </div>
		            </form>
					</div>
		        </div>
		</div>
	</template>
	<template v-slot:footer>
			<button class="btn btn-primary" type="button" @click="save()">保存</button>
			<button style="margin-left:10px" class="btn btn-default" type="button" @click="close()">关闭</button>
	</template>
</BootstrapDialog>
</template>
<script>
    export default {
        name: "ChangePwd",
		components:{
		},
        data: function () {
            return {
                jsList: [],
                jglxList: [],
                ztList: [],
                model: {
                    yhId: '',
                    xmm: '',//新密码
                    confirmPassword: '' //确认密码
                },
            }
        },
        methods: {
			reset:function(){
				this.jsList = [];
				this.jglxList = [];
				this.ztList =  [];
				this.model = {
				    yhId: '',
				    xmm: '',//新密码
				    confirmPassword: '' //确认密码
				}
			},
			async open(){
				let res = this.$http.post('/htgl/grzx/hq');
				if(res.data){
					this.model.yhId = res.data.id
				}
				this.$refs.dialog.open();
			},
			close:function(){
				this.$refs.dialog.close();
			},	
			afterClose:function(){
				this.$validator.reset();
				this.reset();
			},
            //保存
            save() {
                this.$validator.validateAll().then((result) => {
                    if (result) {//如果表单校验通过才可以保存
                        if (this.model.confirmPassword) {  //确认密码填写
                            this.$http.post('/htgl/xgmm/xg', this.model).then(res => {
                                if (res.data) {
									this.$success('操作成功',()=>{
										this.close();
									});
                                }
                            });
                        }
                    }
                });
            }
        }
    }
</script>
<style scoped>
    

</style>